import { render, staticRenderFns } from "./ISALogin.vue?vue&type=template&id=d90954f8&scoped=true&"
import script from "./ISALogin.vue?vue&type=script&lang=js&"
export * from "./ISALogin.vue?vue&type=script&lang=js&"
import style0 from "./ISALogin.vue?vue&type=style&index=0&id=d90954f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90954f8",
  null
  
)

export default component.exports